import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './RessourcesPage.module.css';

const RessourcesPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Ressources — Brands2Buyers</title>
        <meta property="og:title" content="Ressources — Brands2Buyers" />
        <meta name="twitter:title" content="Ressources — Brands2Buyers" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <section className={styles.header}>
        <h1 className={styles.title}>Ressources</h1>
      </section>

      <section className={styles.content}>
        <div className={styles.container}>
          <p className={styles.text}>
            Cette page sera bientôt disponible avec toutes nos ressources utiles.
          </p>
        </div>
      </section>
    </>
  );
};

export default RessourcesPage;
